/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_BadgeInputs */

const et_about_badge = /** @type {(inputs: About_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meist`)
};

const en_about_badge = /** @type {(inputs: About_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Us`)
};

/**
* | output |
* | --- |
* | "About Us" |
*
* @param {About_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const about_badge = /** @type {((inputs?: About_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_about_badge(inputs)
	return en_about_badge(inputs)
});